<div class="loader" *ngIf="loading">
	<div class="spinner spinner-bubble spinner-bubble-primary mr-3"></div>
</div>
